import { createGlobalStyle } from 'styled-components';
import { breakPoint } from './var';

const Typography = createGlobalStyle`
  p, li {
    letter-spacing: 0.5px;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  h1,h2,h3,h4,h5,h6 {
    line-height: 1.3;
    font-weight: 500;
    margin-top: 0;
    margin-bottom: 1.2rem;
  }

  h3, .h3 {
    font-size: 2.4rem;
    @media (min-width: ${breakPoint.min}) {
      font-size: 3.2rem;
    }
  }
  a {
    color: var(--black);
    text-decoration: none
  }
  .text-primary {
    color: var(--primary);
  }
  .text-secondary {
    color: var(--secondary)
  }
  .text-tertiary {
    color: var(--tertiary);
  }
  .center {
    text-align: center;
  }
`;

export default Typography;
